<template>
  <div style="font-size:12px">
    <div class="row mb-3">
      <div class="col-6">
        <dl class="row">
          <dt class="col-sm-5">Order Total:</dt>
          <dd class="col-sm-7">{{data.Summary.OrderTotal}}</dd>

          <dt class="col-sm-5">Line Items:</dt>
          <dd class="col-sm-7">{{data.Summary.Items}}</dd>

          <dt class="col-sm-5">Order Created:</dt>
          <dd class="col-sm-7">{{data.Summary.OrderCreated}}</dd>

          <dt class="col-sm-5">Order Imported:</dt>
          <dd class="col-sm-7">{{data.Summary.OrderImported}}</dd>
        </dl>
      </div>
      <div class="col-6">
        <dl class="row">
          <dt class="col-sm-5">Site Order ID:</dt>
          <dd class="col-sm-7">{{data.Summary.SiteOrderId}}</dd>

          <dt class="col-sm-5">Secondary Site Order ID:</dt>
          <dd class="col-sm-7">{{data.Summary.SecondarySiteOrderId}}</dd>

          <dt class="col-sm-5">Channel Advisor Order ID:</dt>
          <dd class="col-sm-7">{{data.Summary.ChannelAdvisorOrderId}}</dd>

          <dt class="col-sm-5">Seller Order ID:</dt>
          <dd class="col-sm-7">{{data.Summary.SellerOrderId}}</dd>
        </dl>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <dl class="row">
          <dt class="col-sm-5">Estimated Ship Date:</dt>
          <dd class="col-sm-7">{{data.Summary.EstimatedShipDate}}</dd>

          <dt class="col-sm-5">Must Deliver By Date:</dt>
          <dd class="col-sm-7">{{data.Summary.MustDeliverByDate}}</dd>
        </dl>
      </div>
      <div class="col-6">
        <dl class="row">
          <dt class="col-sm-5">Buyer User ID:</dt>
          <dd class="col-sm-7">{{data.Summary.BuyerUserID}}</dd>

          <dt class="col-sm-5">Buyer Email:</dt>
          <dd class="col-sm-7">{{data.Summary.BuyerEmail}}</dd>
        </dl>
      </div>
    </div>

<div class="card shadow mb-4">
      <div class="card-body text-align-left">

        <div class="row">
          <div class="col-md-6">
              <div class="row" v-for="(status, index) in data.Summary.Status" :key="index" >
                <p class="col-6 no-margin">
                {{index}}:
                </p>
                <p class="col-6 no-margin">
                  {{status}}
                </p>
              </div>

          </div>
          <div class="col-md-6">
            <div class="row">
                <p class="col-6 no-margin">
                  Request Shipping Carrier:
                </p>
                <p class="col-6 no-margin">
                  {{data.Summary.RequestedShippingCarrier}}<br>
                </p>
                <p class="col-6 no-margin">
                  Request Shipping Class:
                </p>
                <p class="col-6 no-margin">
                  {{data.Summary.RequestedShippingClass}}<br>
                </p>
                <p class="col-6 no-margin">
                  Distribution Center:
                </p>
                <p class="col-6 no-margin">
                  {{data.Summary.DistributionCenter}}<br>
                </p>
            </div>
          </div>
        </div>
        <br><br>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
                <p class="col-6 no-margin">
                  Payment Method:
                </p>
                <p class="col-6 no-margin">
                  {{data.Summary.PaymentMethod}}<br>
                </p>
                <p class="col-6 no-margin">
                  Merchant Reference Number:
                </p>
                <p class="col-6 no-margin">
                  {{data.Summary.MerchantReferenceNumber}}<br>
                </p>
                <p class="col-6 no-margin">
                  Currency:
                </p>
                <p class="col-6 no-margin">
                  {{data.Summary.Currency}}<br>
                </p>
            </div>
          </div>

        </div>
        <br><br>
        <div class="row">
          <div class="col-md-6">
            <h5> Shipping </h5>
            <div class="row">
                <p class="col-6 no-margin">
                  Name:
                </p>
                <p class="col-6 no-margin">
                  {{data.Shipping.Name}}<br>
                </p>
                <p class="col-6 no-margin">
                  Company Name:
                </p>
                <p class="col-6 no-margin">
                  {{data.Shipping.CompanyName}}<br>
                </p>
                <p class="col-6 no-margin">
                  Status:
                </p>
                <p class="col-6 no-margin">
                  {{data.Shipping.Status}}<br>
                </p>
                <p class="col-6 no-margin">
                  Email:
                </p>
                <p class="col-6 no-margin">
                  {{data.Shipping.Email}}<br>
                </p>
                <p class="col-6 no-margin">
                  Phone:
                </p>
                <p class="col-6 no-margin">
                  {{data.Shipping.Phone}}<br>
                </p>
                <p class="col-6 no-margin">
                  Instructions:
                </p>
                <p class="col-6 no-margin">
                  {{data.Shipping.Instructions}}<br>
                </p>
                <p v-if="this.CA" class="col-6 no-margin">
                  Tracking Number:
                </p>
                <p v-if="this.CA" class="col-6 no-margin">
                  {{data.Shipping.TrackingNumber}}<br>
                </p>
            </div>
          </div>
          <div class="col-md-6">
            <h5> Billing </h5>
            <div class="row">
              <p>
                <label class="col-6 no-margin">
                  Name:
                </label>
                <label class="col-6 no-margin">
                  {{data.Billing.Name}}<br>
                </label>
                <label class="col-6 no-margin">
                  Company Name:
                </label>
                <label class="col-6 no-margin">
                  {{data.Billing.CompanyName}}<br>
                </label>
                <label class="col-6 no-margin">
                  Address:
                </label>
                <label class="col-6 no-margin">
                  {{data.Billing.Address}}<br>
                </label>
              </p>
            </div>
          </div>

          <div class="col-md-12">
            <br><br>
            <marketplaces-grid
              :data="skusGridData"
              :columns="skusGridColumns"
              :filter-key="skusSearchQuery"
            />
            <b-pagination
              size="md"
              v-model="skusPage"
              :per-page="20"
              :total-rows="skusTotalRows"
              align="right"
              @change="changePage($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import grid from '../MarketplacesGrid/MarketplacesGrid.vue';
import { BPagination } from 'bootstrap-vue';
// register the grid component
export default {
  name: 'order-detail',
  components: {
    'marketplaces-grid': grid,
    'b-pagination': BPagination,
  },
  props: {
    CA: Boolean,
    data: Object,
  },
  data() {
    return {
      skusGridData: [],
      skusGridColumns: [
        {
          column: 'Image', index: 'Image', type: 'raw',
        },
        {
          column: 'SKU', index: 'SKU', type: 'raw',
        },
        {
          column: 'Description', index: 'Description', type: 'raw',
        },
        {
          column: 'Unit Price', index: 'UnitPrice', type: 'raw',
        },
        {
          column: 'Quantity', index: 'Quantity', type: 'raw',
        },
        {
          column: 'Item Total', index: 'ItemTotal', type: 'raw',
        },
      ],
      skusTotalRows: 0,
      skusPage: 1,
      skusSearchQuery: '',
    };
  },
  mounted() {
    this.skusGridData = this.data.Items;
    this.skusTotalRows = this.skusGridData.length;
  }
};
</script>